import React, { useRef } from "react";
import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import {
  setToastInfoForAccountStatus,
  updateUserStatus,
} from "../../../../../app/modules/Auth/_redux/userProfileSlice";
import ConfigurationToastMessage from "../../../../../app/modules/Configuration/pages/Configuration/Util/ConfigurationToastMessage";
import { actions } from "../../../../../app/modules/Dashboard/_redux/dashboardRedux";
import { authLogoutSession, isCallCenterEnabled, isSSO, logoutCallback } from "../../../../../app/util/helpers";
import { useMobileViewport } from "../../../../../app/util/mobileViewPort";
import { TextWrap } from "../../../../../app/util/showmore";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { statusColorCodes } from "../QuiclUserToggler";
import { Tracker } from "../../../../../app/util/analytics";
import { FormHelperText } from "@material-ui/core";
import * as helpers from "../../../../../app/util/helpers";



const logoutStatus = {
  label: "Logged Out",
  value: "Logged Out",
};

export const UserStatusDropdown = () => {
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { user, custom_breaks_enabled } = useSelector((state) => state.auth);
  const { selectedStatus, customBreakOptions } = useSelector(
    (state) => state.userProfileSlice
  );

  const isMobileView = useMobileViewport();

  let menuStyles = {
    top: "25px",
    right: "10px",
  };
  if (isMobileView) {
    menuStyles = {
      top: "35px",
      right: "-8px",
      minWidth: "235px",
    };
  }

  const statusDropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      border: "0 !important",
      backgroundColor: "transparent",
      color: "#2f368a",
      fontWeight: "500",
      fontSize: "12px",
      boxShadow: "0 !important",
      cursor: "pointer",
      maxWidth: "280px",
      minWidth: "200px",
      width: "200px",
      "&:hover": {
        border: "0 !important",
      },
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        overflow: "hidden",
        wordBreak: "break-word",
        paddingLeft:
          customBreakOptions.find(
            (breakType) => breakType["value"] === data["value"]
          ) && "24px",
        cursor: isDisabled ? "not-allowed" : "pointer",
        color: isSelected ? "#fff" : isDisabled ? "hsl(0,0%,80%)" : "#2a2c30",
      };
    },
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "#b5b5c3",
      "&:hover": {
        color: "#b5b5c3",
      },
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: statusColorCodes[selectedStatus["value"]],
    }),
    menu: (provided, state) => ({
      ...provided,
      ...menuStyles,
    }),
  };

  const loadingState = (resource, status) => {
    dispatch(
      actions.setLoadingState({
        resource: resource,
        loading_state: status,
      })
    );
  };

  const handleOnStatusChange = async (selectedStatus) => {
    loadingState("update_userStatus", "loading");
    const params = {
      ...(custom_breaks_enabled &&
        customBreakOptions.find(
          (breakType) => breakType["value"] === selectedStatus["value"]
        ) && {
          value: "On Break",
          custom_type: selectedStatus.value,
        }),
    };
    dispatch(
      updateUserStatus({
        selectedStatus: selectedStatus,
        userId: user.user_id,
        customBreak: params,
      })
    ).then((res) => {
      setIsDisabled(true)
      if (res.error) {
        setIsDisabled(false)
        dispatch(
          setToastInfoForAccountStatus({
            open: true,
            snackbarMessage: "Status update failed",
            severity: "error",
          })
        );
      } else {
        dispatch(
          setToastInfoForAccountStatus({
            open: true,
            snackbarMessage: "Status updated successfully",
            severity: "success",
          })
        );
        setIsVisible(true)
        setTimeout(function() {
          setIsVisible(false)
          setIsDisabled(false)
        }, 5000); 
      }
    });
  };

  const statusOptions = [
    {
      value: "Available",
      label: "Available",
    },

    custom_breaks_enabled
      ? {
          value: 2,
          label: "On Break",
          options: [...customBreakOptions],
        }
      : {
          value: "On Break",
          label: "On Break",
        },
  ];
  const { statusToastInfo } = useSelector((state) => state.userProfileSlice);

  const handleCloseSnackbar = () => {
    dispatch(closeSnackbar());
  };

  return (
    <>
      <div className="d-flex align-items-center" style={{position:'relative'}}>
        <span
          className="d-block"
          style={{
            width: "14px",
            height: "14px",
            borderRadius: "99px",
            backgroundColor: statusColorCodes[selectedStatus["value"]],
          }}
        ></span>
        
        <Select
          options={statusOptions}
          value={selectedStatus}
          isSearchable={false}
          isOptionDisabled={(option) => option.disabled}
          onChange={handleOnStatusChange}
          isDisabled={isDisabled}
          styles={statusDropdownStyle}
          components={{
            IndicatorSeparator: () => null,
          }}
          theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary50: "transparent",
              primary25: "transparent",
              primary: "#2c3687",
            },
          })}
          
        />
         {isVisible && (
         <FormHelperText  style={{
          display: "block",
          position: "absolute",
          bottom: '-10px'
        }}>Status can be changed after 5sec</FormHelperText>
      )}
        
      </div>
      {isMobileView && (
        <ConfigurationToastMessage
          severity={statusToastInfo.severity}
          snackbarMessage={statusToastInfo.snackbarMessage}
          open={statusToastInfo.open}
          handleCloseSnackbar={handleCloseSnackbar}
          width="auto"
        />
      )}
    </>
  );
};

export const UserProfileImageWithStatus = () => {
  const { user } = useSelector((state) => state.auth);
  const { selectedStatus } = useSelector((state) => state.userProfileSlice);
  const isMobileView = useMobileViewport();

  const getStatusColor = () => (
    <span
      style={{
        display: "block",
        width: "10px",
        height: "10px",
        borderRadius: "99px",
        marginLeft: "26px",
        marginTop: "-7px",
        position: "absolute",
        backgroundColor: statusColorCodes[selectedStatus?.value],
      }}
    ></span>
  );

  return (
    <>
      <span className="user-symbol">
        <span>{user.first_name.toUpperCase()[0]}</span>
        <div
          style={{
            position: "relative",
            right: "10px",
            ...(isMobileView ? { top: "10px" } : { top: "7px" }),
          }}
        >
          {getStatusColor()}
        </div>
      </span>
    </>
  );
};

const closeSnackbar = () => {
  return setToastInfoForAccountStatus({
    open: false,
    snackbarMessage: "",
    severity: "",
  });
};

export function UserProfileDropdown({ setPsuedoEl }) {
  const { user } = useSelector((state) => state.auth);
  const { statusToastInfo } = useSelector((state) => state.userProfileSlice);
  const isMobileView = useMobileViewport();
  const history = useHistory();
  const [viewState, setViewState] = useState(false);
  const dispatch = useDispatch();

  const handleClick = () => {
    setViewState(!viewState);
    setPsuedoEl(!viewState);
  };

  const handleCloseSnackbar = () => {
    dispatch(closeSnackbar());
  };

  const loadingState = (resource, status) => {
    dispatch(
      actions.setLoadingState({
        resource: resource,
        loading_state: status,
      })
    );
  };

  const handleUserStatus =async () => {
    if(helpers.isCallCenterEnabled()){
    await dispatch(
      updateUserStatus({
        selectedStatus: logoutStatus,
        userId: user.user_id,
      })
    ).then((res) => {
      if (res.error) {
        dispatch(
          setToastInfoForAccountStatus({
            open: true,
            snackbarMessage: "Status update failed",
            severity: "error",
          })
        );
      } else {
        dispatch(
          setToastInfoForAccountStatus({
            open: true,
            snackbarMessage: "Status updated successfully",
            severity: "success",
          })
        );
      }
    });
  }
    try {
      if(process.env.REACT_APP_ENV == 'dev') {
        setTimeout(() => { window.location = "/logout"; }, 10);
        return;
      };
      authLogoutSession(dispatch, logoutCallback);
    } catch (e) {
      loadingState("iframe_logout", "loaded");
      setTimeout(() => { window.location.href = process.env.REACT_APP_IFRAME_BASE_URL; }, 10);
    }
  };

  useEffect(() => {
    if (!isCallCenterEnabled() || (!isCallCenterEnabled() && isSSO())) return;
    if (localStorage.getItem("knowlarityUserStatus") === "true")
      dispatch(
        updateUserStatus({
          selectedStatus: { label: "Available", value: "Available" },
          userId: user.user_id,
        })
      ).then((res) => {
        localStorage.setItem("knowlarityUserStatus", "false");
        if (res.error) {
          dispatch(
            setToastInfoForAccountStatus({
              open: true,
              snackbarMessage: "Status update failed",
              severity: "error",
            })
          );
        } else {
          dispatch(
            setToastInfoForAccountStatus({
              open: true,
              snackbarMessage: "Status updated successfully",
              severity: "success",
            })
          );
        }
      });
  }, []);

  return (
    <>
      <Dropdown drop="down" alignRight onToggle={handleClick}>
        <Dropdown.Toggle
          as={DropdownTopbarItemToggler}
          id="dropdown-toggle-user-profile"
        >
          <div
            className={
              "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
            }
          >
            <UserProfileImageWithStatus />
            <span>
              <img
                alt="arrow"
                src={toAbsoluteUrl("/media/sr/icons/angle-up.svg")}
                className="show-profile-icon"
              />
            </span>
          </div>
        </Dropdown.Toggle>

        {viewState && (
          <div className="d-flex">
            <Dropdown.Menu
              className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
              style={{ width: "370px" }}
            >
              <div className="d-flex align-items-center justify-content-center flex-column pt-10 pb-5 px-10">
                <div className="d-flex">
                  <div className="symbol bg-white-o-15 mr-3">
                    <span className="symbol-label text-success font-weight-bold font-size-h4">
                      {user.first_name.toUpperCase()[0]}
                    </span>
                  </div>
                </div>
                <div
                  className="m-0 mt-3 "
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#000",
                    textAlign: "center",
                  }}
                >
                  <TextWrap
                    text={`${user.first_name} ${user.last_name}`}
                    max={30}
                  />
                </div>
                <div
                  className="m-0 mt-1"
                  style={{
                    fontSize: "12px",
                    ...(isMobileView
                      ? { color: "#fff", opacity: "0.6" }
                      : { color: "#464e5f" }),
                    textAlign: "center",
                  }}
                >
                  <TextWrap text={user?.email} max={35} />
                </div>
              </div>
              <hr style={{ borderColor: "#e5eaee" }} className="m-0" />
              {isCallCenterEnabled() && (
                <div className="d-flex align-items-center justify-content-between px-7 py-3">
                  <div>
                    <span
                      style={{
                        color: "#464e5f",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      Status
                    </span>
                  </div>
                  <UserStatusDropdown />
                </div>
              )}

              <hr style={{ borderColor: "#e5eaee" }} className="m-0" />
              <div className="py-8 d-flex justify-content-center">
                {true && (
                  <div>
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        handleUserStatus();
                      }}
                      style={{ color: "#31378e", fontSize: "15px" }}
                      className="font-weight-bold"
                    >
                      Logout
                    </Link>
                  </div>
                )}
              </div>
            </Dropdown.Menu>
          </div>
        )}
      </Dropdown>

      {!isMobileView && (
        <>
          <ConfigurationToastMessage
            severity={statusToastInfo.severity}
            snackbarMessage={statusToastInfo.snackbarMessage}
            open={statusToastInfo.open}
            handleCloseSnackbar={handleCloseSnackbar}
          />
        </>
      )}
    </>
  );
}
